<template>
  <v-abstract-menu-option v-if="inPivotsView" :showing-dialog.sync="showingDialog">
    <template #info>Tamaño página: {{ similarItemsFetch }}</template>
    <template #input>
      <!-- The text field to edit the value -->
      <v-text-field
        v-model="editValue"
        append-icon="check_circle"
        autofocus
        @click:append="setValueAndCloseDialog"
        hide-details
        @keyup.enter="setValueAndCloseDialog"
        label="Tamaño página"
        solo
      />
    </template>
  </v-abstract-menu-option>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "matching"
);

import VAbstractMenuOption from "@/components/settings-menu/AbstractMenuOption";

export default {
  components: {
    VAbstractMenuOption
  },
  data: () => ({
    editValue: null,
    showingDialog: false
  }),
  computed: {
    ...mapState(["similarItemsFetch"]),
    inPivotsView() {
      return this.$route.name === "matching/pivots";
    }
  },
  created() {
    this.editValue = this.similarItemsFetch;
  },
  methods: {
    ...mapActions(["getSimilarItems"]),
    ...mapMutations(["setSimilarItemsFetch"]),
    setValueAndCloseDialog() {
      this.setSimilarItemsFetch(this.editValue);
      this.showingDialog = false;
      return this.getSimilarItems();
    }
  }
};
</script>